<template>
  <div id="dashboard">
    <div id="dashboard">
      <div class="block block-rounded">
        <!-- <div class="block-header block-header-default">
          <h3 class="block-title">车棚信息</h3>
        </div>-->
        <div class="block-content">
          <form
            action="be_forms_elements.html"
            method="POST"
            enctype="multipart/form-data"
            onsubmit="return false;"
          >
            <div class="row push">
              <div class="col-lg-4">
                <!-- <el-upload
                  class="avatar-uploader dz-image-240"
                  action
                  :show-file-list="false"
                  disabled
                >
                  <img v-if="thumbnallUrl" :src="thumbnallUrl" style="width:100%;" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload> -->
              </div>
              <div class="col-lg-8 col-xl-5">
                <div class="form-group">
                  <label>所在区域</label>
                  <div class="col-sm-12 p-0">
                    <select
                      class="form-control width-33"
                      @change="provinceSel()"
                      v-model="pro"
                      disabled
                    >
                      <option selected="selected" disabled="disabled" value>请选择</option>
                      <option
                        v-for="(item,index) in provinceList"
                        :key="index"
                        :value="item.DISTRICT_CODE"
                      >{{item.DISTRICT_NAME}}</option>
                    </select>
                    <select
                      class="form-control width-33"
                      @change="citySel()"
                      v-model="city"
                      disabled
                    >
                      <option selected="selected" disabled="disabled" value>请选择</option>
                      <option
                        v-for="(item,index) in cityList"
                        :key="index"
                        :value="item.DISTRICT_CODE"
                      >{{item.DISTRICT_NAME}}</option>
                    </select>
                    <select class="form-control width-33" @change="disSel()" disabled v-model="dis">
                      <option selected="selected" disabled="disabled" value>请选择</option>
                      <option
                        v-for="(item,index) in districtList"
                        :key="index"
                        :value="item.DISTRICT_CODE"
                      >{{item.DISTRICT_NAME}}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>小区名称</label>
                    <select
                      class="form-control col-sm-12"
                      :value="message?message.CELL_ID:''"
                      disabled
                    >
                      <option selected="selected" disabled="disabled" value>请选择</option>
                      <option
                        v-for="(item,index) in cellList"
                        :key="index"
                        :value="item.CELL_ID"
                      >{{item.CELL_NAME}}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>车棚名称</label>
                    <input
                      type="text"
                      class="form-control"
                      disabled
                      :value="message?message.CARPORT_NAME:''"
                    />
                  </div>
                  <div class="form-group inline-block" style="width:48%;margin-right:4%">
                    <label>坐标经度</label>
                    <input
                      type="text"
                      class="form-control"
                      disabled
                      :value="message?message.GPS_LNG:''"
                    />
                  </div>
                  <div class="form-group inline-block" style="width:48%;">
                    <label>坐标纬度</label>
                    <input
                      type="text"
                      class="form-control"
                      disabled
                      :value="message?message.GPS_LAT:''"
                    />
                  </div>
                  <div class="form-group inline-block" style="width:100%;">
                    <label>仅白名单用户</label>
                    <select disabled class="form-control" :value="message?message.AUTH_TYPE:''">
                      <option selected="selected" disabled="disabled" value>请选择</option>
                      <option
                        v-for="(item,index) in authTypeList"
                        :key="index"
                        :value="item.value"
                      >{{item.label}}</option>
                    </select>
                  </div>
                  <!-- <div class="form-group inline-block" style="width:48%;margin-right:4%">
                    <label  >联系人姓名</label>
                    <input
                      type="text"
                      class="form-control"
                      
                      disabled
                      :value="message?message.CONTACTS:''"
                      maxlength="20"
                    />
                  </div>
                  <div class="form-group inline-block" style="width:48%;">
                    <label  >联系人电话</label>
                    <input
                      type="text"
                      class="form-control"
                      
                      disabled
                      :value="message?message.MOBILE:''"
                    />
                  </div>
                  <div class="form-group inline-block" style="width:48%;margin-right:4%">
                    <label  >联系人邮箱</label>
                    <input
                      type="text"
                      class="form-control"
                      
                      disabled
                      :value="message?message.EMAIL:''"
                    />
                  </div>-->
                </div>
              </div>
            </div>
          </form>
        </div>
        <!-- END Page Content -->
      </div>
    </div>
  </div>
</template>

<script>
import Util from "../../../Util.js";

export default {
  name: "index",
  data() {
    return {
      provinceList: [],
      cityList: [],
      districtList: [],
      cellList: [],
      pro: "",
      city: "",
      dis: "",
      thumbnallUrl: "",
      message: null,
      form: {
        cellDistrictCode: "",
        cellId: ""
      },
      authTypeList: [
        {
          value: 0,
          label: "否"
        },
        {
          value: 1,
          label: "是"
        }
      ]
    };
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getEntry();
        }
      },
      immediate: true,
      deep: true
    },
    "$route.params.id": {
      handler: function(val, oldVal) {
        this.getEntry();
        this.getProvince();
        this.getCarport(this.$route.params.id);
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.getEntry();
    this.getProvince();
    this.getCarport(this.$route.params.id);
  },
  methods: {
    getCarport(val) {
      this.$http.get(`${Util.searchURL}/Carport/GetByCellId/${val}`).then(
        res => {
          if (res.data.code === 200 && res.data.data) {
            // this.provinceList = res.data.data
            let d = res.data.data;
            this.message = d;
            this.thumbnallUrl =
              d.THUMBNAIL_URL != null
                ? d.THUMBNAIL_URL
                : d.THUMBNAIL
                ? "data:image/png;base64," + d.THUMBNAIL
                : "";
            Util.displayAreaCell(d.CELL_ID, this, true, true);
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    getEntry() {
      this.$http
        .get(`${Util.searchURL}/FlatComplex/Info/${this.$route.params.id}`)
        .then(result => {
          this.entry = result.data.data;
          this.$store.commit("setParam", {
            entry: this.entry
          });
        });
    },
    getProvince() {
      this.$http.get(`${Util.searchURL}/Province/ListAll`).then(
        res => {
          if (res.data.code === 200) {
            this.provinceList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    provinceSel() {
      this.$http.get(`${Util.searchURL}/City/ListByProvince/${this.pro}`).then(
        res => {
          if (res.data.code === 200) {
            this.cityList = res.data.data;
            this.city = "";
            this.districtList = [];
            this.dis = "";
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    citySel() {
      this.$http.get(`${Util.searchURL}/District/ListByCity/${this.city}`).then(
        res => {
          if (res.data.code === 200) {
            this.districtList = res.data.data;
            this.dis = "";
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    disSel() {
      this.$http
        .get(`${Util.searchURL}/FlatComplex/ListByDistrict/${this.dis}`)
        .then(
          res => {
            if (res.data.code === 200) {
              this.cellList = res.data.data;
            }
          },
          err => {
            console.log(err);
          }
        );
    }
  }
};
</script>

